import React from 'react';
import './Topbar.css';

const Topbar = () => {
  return (
    <header className="topbar">
      <div className="search-box">
        <span>⌕</span>
        <input placeholder="Search events, users, bookings..." />
      </div>

      <div className="topbar-actions">
        <button className="language-btn">EN</button>

        <div className="admin-info">
          <div>
            <h4>Admin User</h4>
            <p>admin@spine.com</p>
          </div>
          <div className="avatar">♡</div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;